import { isNullish } from "./systemUtils";
// import * as crypto from 'crypto'

export const createUuid = () => {
  return uuid4();
};

export const getContainerUuid = (uuid) => {
  return `C-${uuid}`;
};

export const getPanelUuid = (uuid) => {
  return `P-${uuid}`;
};

export const getMainUuid = (uuid) => {
  return `S-${uuid}`;
};

export const parseUuid = (uuid, index) => {
  if (isNullish(index)) {
    return uuid;
  }

  return `${uuid}-${index}`;
};

//------------------------------------------------------------------------

// https://stackoverflow.com/questions/105034/how-do-i-create-a-guid-uuid
const uuid4 = () => {
  return "10000000-1000-4000-8000-100000000000".replace(/[018]/g, (c) =>
    ((c ^ Math.floor(Math.random() * 256)) & (15 >> (c / 4))).toString(16)
  );
};